import { useQuery, UseQueryOptions } from 'react-query';

import { DealRequestAllocation, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDealRequestAllocationQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<DealRequestAllocation, unknown, DealRequestAllocation>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Allocation(guid),
		() => AxiosUtils.getResponseData<DealRequestAllocation>(api.get(CerebroApiEndpoints.Allocation(guid))),
		options
	);
}
